module.exports = __webpack_public_path__ + "img/smb_triangle.1a7db6fa.svg";